import { render, staticRenderFns } from "./widgetGradientColorBarchart.vue?vue&type=template&id=b87511de&scoped=true"
import script from "./widgetGradientColorBarchart.vue?vue&type=script&lang=js"
export * from "./widgetGradientColorBarchart.vue?vue&type=script&lang=js"
import style0 from "./widgetGradientColorBarchart.vue?vue&type=style&index=0&id=b87511de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87511de",
  null
  
)

export default component.exports